import { NgClass } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { AutocompleteComponent } from '../../../../lib/autocomplete/autocomplete.component';
import { ProviderFactory } from '../../../../lib/provider-factory';

@Component({
  selector: 'app-address-country-field',
  templateUrl: './address-country-field.component.html',
  imports: [
    NgClass,
    AutocompleteComponent
  ],
  styleUrls: ['../../address-action.component.scss']
})
export class AddressCountryFieldComponent implements OnInit {
  @Input() countryControl: FormControl;
  @Input() inputCleared: Subject<void> = new Subject<void>();

  pickerPlaceholderText: string;

  @ViewChild('countryField')
  set fieldValue(v: AutocompleteComponent) {
    setTimeout(() => this.setCountryPickerComponent(v), 0);
  }

  private fieldPickerComponent: AutocompleteComponent;

  constructor(private providerFactory: ProviderFactory) {
  }

  ngOnInit(): void {
  }

  private setCountryPickerComponent(acComponent: AutocompleteComponent): void {
    this.fieldPickerComponent = acComponent;

    const shouldCountryBeEnabled = this.countryControl.enabled;
    if (this.fieldPickerComponent) {
      this.pickerPlaceholderText = 'Loading...';
      this.countryControl.disable();

      // TODO: Error Handling
      this.providerFactory.getCountryProvider(this.countryControl.value).subscribe(provider => {
        this.fieldPickerComponent.setOptionsProvider(provider, this.countryControl.value);
        this.pickerPlaceholderText = undefined;
        if (shouldCountryBeEnabled)
          this.countryControl.enable();
      });
    }
  }

}
